import React from "react";
import ContactHeader from "./contactusHeader";
import Footer from "../../Components/Footer";
import WhatsAppWidget from "../../Components/WhatsappWidget";

function Media() {
  return (
    <main id="media">
      <section id="media">
        <ContactHeader />
        <Footer />
        <WhatsAppWidget />
      </section>
    </main>
  );
}

export default Media;